import type { TabConfig } from './types';

export const TAB_CONFIGS: TabConfig[] = [
  { key: 'smpc', label: 'SmPC' },
  { key: 'annexII', label: 'ANNEX II' },
  { key: 'labelling', label: 'Label' },
  { key: 'packageLeaflet', label: 'PL' },
];

/**
 * What a custom section is called before its author names it — and what the
 * tree shows for one that has no title in the language being read. Display
 * only in that second case: written into the data, it would print as the
 * section's heading in an approved document.
 */
export const CUSTOM_SECTION_TITLE = 'Custom section';
